import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import DegreeService from "../../src/Services/Degree.service";
const DegreeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return DegreeService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return DegreeService.getDegrees(search);
        },
        optionRenderer: function degreeRenderer(degree) {
            return (_jsxs("span", { children: ["[", degree.acronym, "] ", degree.name] }));
        },
    });
};
export default DegreeLookup;
